const headerParam = {
  namespaced: true,
  state: {
    inputAgencyId: 0,
    inputAdvertiserId: 0
  },
  getters: {
    getHeaderAgencyId: state => state.inputAgencyId,
    getHeaderAdvertiserId: state => state.inputAdvertiserId
  },
  mutations: {
    setHeaderAgencyId(state, agencyId) {
      state.inputAgencyId = agencyId
    },
    setHeaderAdvertiserId(state, advertiserId) {
      state.inputAdvertiserId = advertiserId
    }
  },
  actions: {
    setHeaderParamAgencyAdvertiser({ commit }, params) {
      commit('setHeaderAgencyId', params.agencyId)
      commit('setHeaderAdvertiserId', params.advertiserId)
    }
  }
}

export default headerParam
